<template>
  <div class="contact-form-section section-space--ptb_120" id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-7 order-2 order-lg-1">
          <div class="section-title text-left section-space--mb_60">
            <h2 class="font-weight--bold mb-15 wow move-up">
              Confirm your Order
            </h2>
            <span class="section-text_left wow move-up"
              >Kindly input the details and please secure your reference
              code.</span
            >
          </div>

          <div>
            <strong>Reference Number :</strong>
            <h5>{{ refno }}</h5>
            <p>Kindly Secure this Reference Number for future References.</p>
            <hr />
            Service Name :
            <p>{{ subject }}</p>
            <br />
            Price :
            <p>{{ presyo }}</p>
            <hr />
          </div>
          <br />
          <div class="contact-from-wrapper wow move-up">
            <div class="contact-page-form">
              <HAlert
                v-if="showAlert && dismissSecs"
                :dismiss-secs="dismissSecs"
                :message="alertMessage"
                :variant="alertType"
              />

              <div class="contact-submit-btn text-center">
                <router-link
                  :to="{
                    name: 'payment',
                    query: {
                      price: presyo,
                      refno: refno,
                      serviceName: subject,
                    },
                  }"
                >
                  <button class="ht-btn ht-btn-md ht-btn--outline loadMore">
                    <i class="fa-solid fa-cart-shopping"></i>Check Out
                  </button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 order-1 order-lg-2">
          <div class="peatures_image-wrap section-space--mb_40">
            <div class="image text-center wow move-up">
              <img
                class="img-fluid"
                src="../assets/img/features/contact-form-image-01.png"
                alt="contact thumb"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HAlert from "@/components/HAlert";
export default {
  components: { HAlert },
  data() {
    return {
      subject: this.$route.query.subject,
      refno: this.$route.query.refno,
      presyo: this.$route.query.price,
    };
  },
};
</script>
